import React from "react";
import { Card, Typography, Descriptions, Tag } from "antd";
import {
  BankOutlined,
  ApartmentOutlined,
  CreditCardOutlined,
  DollarOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

export function BankAccountCard({
  account,
  formatAccountNumber,
  formatMoney,
  getBankLabel,
}) {
  return (
    <Card
      title={
        <span>
          <BankOutlined className="mr-2" />
          Банкны данс
        </span>
      }
      bordered={false}
      className="rounded-xl shadow-sm"
    >
      <Descriptions column={1} size="middle" labelStyle={{ width: 180 }}>
        <Descriptions.Item
          label={
            <span>
              <CreditCardOutlined className="mr-2" />
              Дансны дугаар
            </span>
          }
        >
          <Text strong>
            {formatAccountNumber(account?.accountNumber)}
          </Text>
        </Descriptions.Item>

        <Descriptions.Item label="Банк">
          <Tag color="blue">{getBankLabel(account?.bank)}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Валют">
          <Tag color="green">{account?.currency ?? "-"}</Tag>
        </Descriptions.Item>

        {/* Gmail үлдэгдэл */}
        <Descriptions.Item
          label={
            <span>
              <DollarOutlined className="mr-2" />
              Gmail үлдэгдэл
            </span>
          }
        >
          <Text strong className="text-base">
            {formatMoney(account?.gmailBalance, account?.currency)}
          </Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <span>
              <DollarOutlined className="mr-2" />
              Үлдэгдэл
            </span>
          }
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full">
            {/* Ориг үлдэгдэл */}
            <div className="rounded-lg border border-blue-100 bg-blue-50 px-4 py-3">
              <div className="text-xs text-slate-500 mb-1">
                Ориг үлдэгдэл
              </div>
              <Text strong className="text-base text-blue-700">
                {formatMoney(account?.balance, account?.currency)}
              </Text>
            </div>

            {/* Хуулганы үлдэгдэл */}
            <div className="rounded-lg border border-amber-100 bg-amber-50 px-4 py-3">
              <div className="text-xs text-slate-500 mb-1">
                Ориг хуулганы үлдэгдэл
              </div>
              <Text strong className="text-base text-amber-700">
                {formatMoney(
                  account?.lastStatementBalance,
                  account?.currency
                )}
              </Text>
            </div>
          </div>
        </Descriptions.Item>

        {/* Хийсвэр үлдэгдэл */}
        <Descriptions.Item
          label={
            <span>
              <DollarOutlined className="mr-2" />
              Хийсвэр үлдэгдэл
            </span>
          }
        >
          <Text strong className="text-base">
            {formatMoney(account?.walletBalance, account?.currency)}
          </Text>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}

export function InstitutionCard({
  institution,
  getInstitutionTypeLabel,
}) {
  return (
    <Card
      title={
        <span>
          <ApartmentOutlined className="mr-2" />
          Байгууллага
        </span>
      }
      bordered={false}
      className="h-full rounded-xl shadow-sm"
    >
      {institution ? (
        <Descriptions column={1} size="middle" labelStyle={{ width: 140 }}>
          <Descriptions.Item label="Байгууллагын нэр">
            <Text strong>{institution.name}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Байгууллагын төрөл">
            <Tag color="purple">
              {getInstitutionTypeLabel(institution.type)}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Text type="secondary">
          Холбогдсон байгууллага байхгүй
        </Text>
      )}
    </Card>
  );
}